// translations
// wrap inside v-html if it includes html
export default {
    install: (app) => {
        app.config.globalProperties.$t = (key, placeholder) => {
            return window.vm.translations[key] || placeholder;
        }
    }
}